var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 206,
    viewBox: "0 0 360 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 137.5L214 183L59 92.5L140 45L300 137.5Z",
    fill: "#E5F7F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M226 206H112.5H-1V71.5L226 206Z",
    fill: "#00B0A6",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.488 132.9C225.658 132.9 227.418 132.188 227.418 131.309C227.418 130.431 225.658 129.719 223.488 129.719C221.317 129.719 219.558 130.431 219.558 131.309C219.558 132.188 221.317 132.9 223.488 132.9Z",
    fill: "#192643"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M229.85 111.004C229.85 116.65 226.17 121.453 223.394 121.453C220.618 121.453 217 117.086 217 111.441C217 105.796 220.618 97 223.394 97C226.17 97 229.85 105.359 229.85 111.004Z",
    fill: "#192643"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M223.488 102.614V131.465",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M219.963 107.885L223.487 112.844",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M226.95 104.143L223.425 109.133",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M226.95 111.129L223.425 116.12",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219.963 114.436L223.487 119.426",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M222.24 131.153C222.24 131.153 223.675 131.902 224.735 131.153",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M144.488 93.9002C146.658 93.9002 148.418 93.188 148.418 92.3095C148.418 91.4309 146.658 90.7188 144.488 90.7188C142.317 90.7188 140.558 91.4309 140.558 92.3095C140.558 93.188 142.317 93.9002 144.488 93.9002Z",
    fill: "#192643"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.85 72.0044C150.85 77.6498 147.17 82.4531 144.394 82.4531C141.618 82.4531 138 78.0865 138 72.4411C138 66.7956 141.618 58 144.394 58C147.17 58 150.85 66.359 150.85 72.0044Z",
    fill: "#192643"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.488 63.6143V92.4652",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140.963 68.8853L144.487 73.8445",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.95 65.1426L144.425 70.133",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.95 72.1294L144.425 77.1198",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M140.963 75.4355L144.487 80.426",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M143.24 92.1533C143.24 92.1533 144.675 92.9019 145.735 92.1533",
    stroke: "#00B0A6",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M213.065 119.688C209.314 119.688 206.273 118.458 206.273 116.939C206.273 115.421 209.314 114.19 213.065 114.19C216.815 114.19 219.856 115.421 219.856 116.939C219.856 118.458 216.815 119.688 213.065 119.688Z",
    fill: "#192643"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M215.216 116.674C215.216 116.674 212.737 117.968 210.904 116.674",
    stroke: "#00B0A6",
    strokeWidth: 2.081,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M220.5 136.237V111.119L206 97.7646L191.501 122.882V153L220.5 136.237Z",
    fill: "#00B0A6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M191.499 122.881L205.998 97.763L154.5 68L140 93L191.499 122.881Z",
    fill: "#192643"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M191.505 122.885L140 92.8823V123L191.505 153.003V122.885Z",
    fill: "#018289"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M204.384 126.215V145.565L211.067 141.684V122.334L204.384 126.215Z",
    fill: "#192643"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M179.964 126.208L173.28 122.328V133.916L179.964 137.797V126.208Z",
    fill: "#192643"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M204.384 145.564L211.067 141.684L204.384 137.372V145.564Z",
    fill: "#101627"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M179.964 137.797L173.28 133.917L179.964 129.604V137.797Z",
    fill: "#101627"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M154.964 111.208L148.28 107.328V118.916L154.964 122.797V111.208Z",
    fill: "#192643"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M154.964 122.797L148.28 118.917L154.964 114.604V122.797Z",
    fill: "#101627"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M129.5 36L48.5 83L-0.5 53.5V3H63.5L129.5 36Z",
    fill: "#00B0A6",
    fillOpacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M268 89L268 142",
    stroke: "#192643",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M268 141H207",
    stroke: "#192643",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M304.333 57.3055C304.333 75.231 289.801 89.7638 271.875 89.7638C253.95 89.7638 239.417 75.231 239.417 57.3055C239.417 39.38 253.95 24.8472 271.875 24.8472C289.801 24.8472 304.333 39.38 304.333 57.3055Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M300.917 54.4583C300.917 72.3839 286.384 86.9167 268.458 86.9167C250.533 86.9167 236 72.3839 236 54.4583C236 36.5328 250.533 22 268.458 22C286.384 22 300.917 36.5328 300.917 54.4583Z",
    fill: "#152954"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M252.534 75.154C254.83 75.154 256.146 73.936 256.146 72.214C256.146 70.464 254.802 69.82 252.8 69.372C251.274 69.022 250.56 68.742 250.56 67.958C250.56 67.286 251.218 66.698 252.184 66.698C253.136 66.698 254.102 67.104 254.942 67.832L255.894 66.544C254.928 65.718 253.78 65.2 252.254 65.2C250.224 65.2 248.796 66.432 248.796 68.112C248.796 69.918 250.182 70.492 252.17 70.954C253.71 71.318 254.396 71.584 254.396 72.382C254.396 73.068 253.78 73.656 252.59 73.656C251.33 73.656 250.308 73.152 249.426 72.354L248.418 73.6C249.482 74.594 250.882 75.154 252.534 75.154ZM261.186 75.168C263.286 75.168 265.064 73.432 265.064 71.374C265.064 69.316 263.286 67.594 261.186 67.594C259.086 67.594 257.308 69.316 257.308 71.374C257.308 73.432 259.086 75.168 261.186 75.168ZM261.186 73.712C259.982 73.712 258.974 72.648 258.974 71.374C258.974 70.114 259.982 69.05 261.186 69.05C262.376 69.05 263.384 70.114 263.384 71.374C263.384 72.648 262.376 73.712 261.186 73.712ZM271.445 67.762V72.34C271.333 73.11 270.591 73.712 269.695 73.712C268.799 73.712 268.169 73.012 268.169 72.032V67.762H266.517V72.368C266.517 74.006 267.623 75.168 269.205 75.168C270.157 75.168 270.997 74.706 271.445 74.034V75H273.153V67.762H271.445ZM278.648 73.446C278.494 73.6 278.228 73.712 277.934 73.712C277.528 73.712 277.22 73.362 277.22 72.872V69.176H278.858V67.762H277.22V65.774H275.554V67.762H274.504V69.176H275.554V73.082C275.554 74.3 276.394 75.168 277.598 75.168C278.144 75.168 278.732 74.944 279.138 74.594L278.648 73.446ZM284.411 67.594C283.445 67.594 282.591 68.056 282.157 68.756V65.214H280.449V75H282.157V70.618C282.157 69.75 282.955 69.05 283.921 69.05C284.817 69.05 285.447 69.75 285.447 70.73V75H287.099V70.394C287.099 68.756 285.993 67.594 284.411 67.594Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M257.875 31.125H278.125V58.875H257.875V31.125Z",
    fill: "#00B0A6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M277.75 31.5V58.5H258.25V31.5H277.75ZM278.5 30.75H257.5V59.25H278.5V30.75Z",
    fill: "#00B0A6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M269.5 33.75H275.5V44.25H269.5V33.75ZM260.5 33.75H266.5V44.25H260.5V33.75ZM269.5 47.25H275.5V56.25H269.5V47.25ZM260.5 47.25H266.5V56.25H260.5V47.25Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M275.5 44C275.102 44 274.721 44.158 274.439 44.4393C274.158 44.7206 274 45.1022 274 45.5C274 45.8978 274.158 46.2794 274.439 46.5607C274.721 46.842 275.102 47 275.5 47C275.898 47 276.279 46.842 276.561 46.5607C276.842 46.2794 277 45.8978 277 45.5C277 45.1022 276.842 44.7206 276.561 44.4393C276.279 44.158 275.898 44 275.5 44Z",
    fill: "#152954"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.499 193.574L247.191 206L360 206V173.5L312.5 146L227.499 193.574Z",
    fill: "#00B0A6",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step_3.8e744870c5f38afe162e39a5ac4464fa.svg";
export { ForwardRef as ReactComponent };